export default {
	common: {
		noMore: "더 이상 데이터가 없습니다",
		noData: "데이터가 없습니다!",
		loading: "로딩 중...",
		gotIt: "알겠습니다",
		confirm: "확인",
		cancel: "취소"
	},
	activity: {
		title: "이벤트",
		rule: "이벤트 규칙",
		stockNotEnough: "상품 재고 부족",
		soldOut: "품절",
		addCartSuccess: "장바구니에 추가되었습니다",
		maxPurchaseLimit: "최대 {num}개까지 구매 가능",
	},
	inivteFriends: {
		title: "친구 초대",
		earn: "적립",
		for: "매",
		eachFriendInvited: "친구 1명 초대",
		myRewards: "내 보상",
		received: "받음",
		invited: "초대함",
		shareNow: "지금 공유",
		welcomeGift: "웰컴 기프트",
		invitedFriends: "초대한 친구",
		noSuccessfulInvites: "성공한 초대가 없습니다",
		howItWorks: "이용 방법",
	},
	document: {
		title: "문서",
	},
}
